/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of Signature Authority
 * @export
 */
export const SignatureAuthority = {
    Individual: 'INDIVIDUAL',
    Collective2: 'COLLECTIVE_2',
    Collective3: 'COLLECTIVE_3',
    Collective4: 'COLLECTIVE_4',
    Collective5: 'COLLECTIVE_5',
    Collective6: 'COLLECTIVE_6',
    Collective7: 'COLLECTIVE_7',
    Collective8: 'COLLECTIVE_8',
    Collective9: 'COLLECTIVE_9',
    Collective10: 'COLLECTIVE_10',
    Collective11: 'COLLECTIVE_11',
    Collective12: 'COLLECTIVE_12',
    Collective13: 'COLLECTIVE_13',
    Collective14: 'COLLECTIVE_14',
    Collective15: 'COLLECTIVE_15',
    Collective16: 'COLLECTIVE_16',
    Collective17: 'COLLECTIVE_17',
    Collective18: 'COLLECTIVE_18',
    Collective19: 'COLLECTIVE_19',
    Collective20: 'COLLECTIVE_20',
    SpecialSeeDocuments: 'SPECIAL_SEE_DOCUMENTS',
    NoSignatureRights: 'NO_SIGNATURE_RIGHTS'
} as const;
export type SignatureAuthority = typeof SignatureAuthority[keyof typeof SignatureAuthority];


export function instanceOfSignatureAuthority(value: any): boolean {
    for (const key in SignatureAuthority) {
        if (Object.prototype.hasOwnProperty.call(SignatureAuthority, key)) {
            if (SignatureAuthority[key as keyof typeof SignatureAuthority] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SignatureAuthorityFromJSON(json: any): SignatureAuthority {
    return SignatureAuthorityFromJSONTyped(json, false);
}

export function SignatureAuthorityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignatureAuthority {
    return json as SignatureAuthority;
}

export function SignatureAuthorityToJSON(value?: SignatureAuthority | null): any {
    return value as any;
}

export function SignatureAuthorityToJSONTyped(value: any, ignoreDiscriminator: boolean): SignatureAuthority {
    return value as SignatureAuthority;
}

